import comprasService from './comprasService';
import type { EstadisticaComprasPorMotivoAdjudicacion } from './types';

export default comprasService;
export type { EstadisticaComprasPorMotivoAdjudicacion };
